module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMBAMAAACdPPCPAAAAMFBMVEX///////////////////////////////////////////////////////////////9Or7hAAAAAD3RSTlMC89jrxKx4aBDq0M+NYFgkox1LAAAAQElEQVQI12NgD1GW///RyLWAIf8/BHxj2A9l/WKQ////jz6Q9ZEBSPzgAzHBLAbe+SgshCxCx3qoKb8RJiNsAwBrDlMCGZla2QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-header-youtube.png
// module id = 292
// module chunks = 114276838955818 159515537771391